import { Observable } from 'rxjs';
import { ProblemModel } from 'src/app/store/problem/model';
import { InteractorResponse } from '../../models/interactor-response';

export abstract class AbstractProblemApiService {
  public abstract getProblems(): Observable<InteractorResponse<ProblemModel[]>>;
  public abstract getProblemById(id: number): Observable<InteractorResponse<ProblemModel>>;
  public abstract saveProblem(problem: ProblemModel): Observable<InteractorResponse<ProblemModel>>;
  public abstract createProblem(problem: ProblemModel): Observable<InteractorResponse<ProblemModel>>;
  public abstract deleteProblem(id: number): Observable<InteractorResponse<null>>;
  public abstract solvedProblem(id: number): Observable<InteractorResponse<ProblemModel>>;
}
